// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* PayTable */
.SSPTable {
  flex: 1 1;
  display: flex;
  position: relative;
  margin-top: 10px;
  background-color: #fff;
}

.SSPTable table {
  position: relative;
  width: 100%;
  text-align: center;
  border-radius: 10px;
  border-collapse: collapse;
  border-style: hidden;
  box-shadow: 0 0 0 1px #e9e9e9;
  overflow: hidden;
}

.SSPTable table thead {
  font-weight: bold;
  background-color: #f9fafb;
}

.SSPTable table tr th {
  padding: 15px 0;
  text-align: center;
  border: 1px solid #ddd;
}

.SSPTable table tr td {
  padding: 15px 0;
  vertical-align: middle;
  color: #505054;
  font-weight: bold;
  border: 1px solid #ddd;
}

.SSPTable table tr td p {
  margin: 0;
}

.SSPTable table tr td p + p {
  font-size: 0.7rem;
}

.SSPTable table tr td input[type=text] {
  padding: 3px 10px;
  height: 40px;
  text-align: right;
  border: 1px solid #e9e9e9;
  border-radius: 5px;
}

.SSPTable table tr td input[type=text].RB {
  border-color: red;
}

.SSPTable table tr td input[type=text].W90 {
  width: 90%;
}

.SSPTable table tr td input[type=text].W80 {
  width: 80%;
}

.SSPTable table tr td input[type=text].W70 {
  width: 70%;
}

.SSPTable table tr td input[type=text].W60 {
  width: 60%;
}

.SSPTable table tr td input[type=text].W50 {
  width: 50%;
}

.SSPTable table tr td input[type=text].W40 {
  width: 40%;
}

.SSPTable table tr td input[type=text].W30 {
  width: 30%;
}

.SSPTable table tr td input[type=text].W20 {
  width: 20%;
}

.SSPTable table tr td .AmountTd {
  display: flex;
  justify-content: center;
}

.SSPTable table tr td .AmountTd div {
  display: flex;
  flex: 1 1;
  justify-content: flex-end;
  max-width: 177px;
}

.SectionPayInput {
  display: flex;
  flex-direction: column;
}

.SectionPayInput .SectionPayInner {
  display: flex;
  justify-content: flex-end;
  align-items: center;
}

.SectionPayInput .SectionPayInner + .SectionPayInner {
  margin-top: 5px;
}

.SectionPayInput input {
  margin: 0 5px;
}

.SectionPayInput span {
  margin-right: 3%;
  font-size: 1rem;
  font-weight: 400;
  color: #868686;
}

.SSPTableLoading {
  position: absolute;
  display: flex;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  align-items: center;
  justify-content: center;
  border-radius: 20px;
  background-color: rgba(0, 0, 0, 0.1);
}

.spinnerIcon {
  animation: spin 2s linear infinite;
  font-size: 2em;
  color: #555;
}

/* SectionSumInput */
.SectionSumInput {
  display: flex;
  margin: 0 5%;
  justify-content: flex-end;
}

.SectionSumInput .SectionSumType {
  display: flex;
  margin-right: 2px;
  align-items: center;
}

.SectionSumInput .SectionSumType button {
  width: 30px;
  height: 30px;
  color: #aaa;
  border-radius: 4px;
  border: 1px solid #e9e9e9;
}

.SectionSumInput .SectionSumType button.isActive {
  color: #fff;
  background-color: #bc1a21;
}

.SectionSumInput .SectionSumType button:not(.isActive):hover {
  background-color: #eee;
}

/* SectionPopup */
.SectionPopup {
  z-index: 2;
  display: flex;
  align-items: center;
  max-height: 70vh;
  justify-content: center;
}

.SectionPopupInner {
  z-index: 2;
  position: relative;
  display: flex;
  min-width: 420px;
  max-height: 99.5%;
  flex-direction: column;
}

.SectionAdd {
  display: flex;
  margin-top: 5%;
  justify-content: center;
}

.SectionAdd input {
  padding: 10px;
  width: 50%;
  border: 1px solid #ddd;
  border-radius: 5px;
  font-size: 1rem;
}

.SectionAdd input::placeholder {
  padding: 0 5px;
  color: #999;
  font-size: 1rem;
}

.SectionAdd button {
  display: flex;
  margin-left: 10px;
  width: 20%;
  border: 1px solid #bc1a21;
  border-radius: 5px;
  font-size: 1rem;
  align-items: center;
  justify-content: center;
}

.SectionAdd button:hover {
  color: white;
  background-color: #bc1a21;
}

.SectionList {
  display: flex;
  margin-top: 5%;
  align-items: center;
  flex-direction: column;
  border: 1px solid #f5f5f5;
  overflow-y: auto;
}

.SectionItem {
  display: flex;
  padding: 10px;
  width: 100%;
  justify-content: center;
  align-items: center;
}

.SectionListCheckBox {
  display: flex;
  width: 100%;
  align-items: center;
  justify-content: space-between;
}

.SectionListCheckBox input {
  display: none;
}

.SectionListCheckBox label {
  display: flex;
  margin: 0;
  align-items: center;
  cursor: pointer;
}
.SectionListCheckBox label:hover {
  font-weight: bold;
}

.SectionListCheckBox label .SectionListCheckBoxIcon {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  width: 22px;
  height: 24px;
  padding: 0;
}

.SectionListName {
  display: flex;
  margin-left: 20px;
  justify-content: flex-start;
  align-items: center;
}

.SectionListName span {
  display: flex;
  min-width: 30%;
  align-content: center;
}

.SectionListCheckBox button {
  padding-left: 10px;
  display: flex;
}

.SectionPopupBg {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.3);
}

.DP_Top {
  display: flex;
  flex-direction: column;
}

.DP_TopBackArea {
  display: flex;
  margin-bottom: 2%;
}

.DP_TopBackArea button {
  display: flex;
  padding: 0.5% 3%;
  align-items: center;
  justify-content: center;
  background-color: #a6c23d;
  border: 1px solid #a6c23d;
  border-radius: 10px;
}

.DP_TopBackArea button:hover {
  border-color: #000;
}

.DP_TopBackArea button span {
  display: flex;
  margin-left: 10px;
  color: white;
  font-size: 1.1rem;
}

.DP_TopBg {
  position: relative;
}

.DP_TopCnt {
  display: flex;
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  padding: 0 5%;
  color: white;
  align-items: center;
}

.DP_TopName {
  display: flex;
  flex-direction: column;
}

.DP_TopCnt i {
  margin: 0 2% 0 5%;
  width: 1px;
  height: 50%;
  background-color: #fff;
}

.DP_TopInfo {
  display: flex;
  flex-direction: column;
}

.DP_TopCnt span {
  color: white;
  font-size: 1.5rem;
}

.DP_TopCnt span + span {
  font-size: 1.3rem;
}

.DP_TopCnt strong {
  color: white;
  font-size: 2.5rem;
}

.DP_Mid {
  display: flex;
  flex-direction: column;
}

.DP_Mid .DP_MidBar {
  width: 1px;
  height: 100%;
  background-color: #C7C7C7;
}

.DP_MidMenu {
  display: flex;
  margin-top: 5%;
  justify-content: space-evenly;
}

.DP_MidMenu button {
  flex: 1 1;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0;
  font-size: 1.2rem;
}

.DP_MidMenu button span {
  margin-top: 10px;
}

.DP_MidSection {
  display: flex;
  margin-top: 4%;
  padding-top: 4%;
  flex-direction: column;
}

.SectionTitle {
  display: flex;
}

.SectionTitle span {
  display: flex;
  padding: 10px 0;
  width: 10%;
  color: white;
  justify-content: center;
  border-radius: 27px;
}

.DP_MidEmpInfo {
  margin-top: 10px;
}

.DP_MidEmpInfo table {
  width: 100%;
  border-collapse: collapse;
}

.DP_MidEmpInfo table thead {
  background-color: #F3FBFF;
}

.DP_MidEmpInfo table {
  width: 100%;
}

.DP_MidEmpInfo table th {
  padding: 10px 0;
  text-align: center;
  font-weight: bold;
  box-shadow: 1px 0 0 0 #C5C5C5, 0 1px 0 0 #C5C5C5, 1px 1px 0 0 #C5C5C5, 1px 0 0 0 #C5C5C5 inset, 0 1px 0 0 #C5C5C5 inset;
}

.DP_MidEmpInfo table td {
  padding: 10px 0;
  text-align: center;
  box-shadow: 1px 0 0 0 #C5C5C5, 0 1px 0 0 #C5C5C5, 1px 1px 0 0 #C5C5C5, 1px 0 0 0 #C5C5C5 inset, 0 1px 0 0 #C5C5C5 inset;
  background-color: #fff;
}

.DP_SectionTableArea {
  margin-top: 10px;
  display: flex;
}

.DP_SectionTable {
  flex: 1 1;
  display: flex;
  flex-direction: column;
}

.DP_SectionTable strong {
  padding-bottom: 10px;
  font-size: 1.2rem;
}

.DP_SectionTable table {
  border-collapse: collapse;
}

.DP_SectionTable table thead {
  background-color: #F3FBFF;
}

.DP_SectionTable table th {
  padding: 10px 0;
  text-align: center;
  font-weight: bold;
  font-size: 1.2rem;
  border: 1px solid #D5D5D5;
}

.DP_SectionTable table td {
  padding: 10px 20px;
  border: 1px solid #D5D5D5;
  background-color: #fff;
}

.DP_SectionTable table td:last-child {
  text-align: right;
}

.DP_SectionTable table td.DP_SectionTableFormula {
  text-align: center;
}`, "",{"version":3,"sources":["webpack://./src/components/salary/salary.scss"],"names":[],"mappings":"AAAA,aAAA;AACA;EACI,SAAA;EACA,aAAA;EACA,kBAAA;EACA,gBAAA;EACA,sBAAA;AACJ;;AACA;EACI,kBAAA;EACA,WAAA;EACA,kBAAA;EACA,mBAAA;EACA,yBAAA;EACA,oBAAA;EACA,6BAAA;EACA,gBAAA;AAEJ;;AAAA;EACI,iBAAA;EACA,yBAAA;AAGJ;;AADA;EACI,eAAA;EACA,kBAAA;EACA,sBAAA;AAIJ;;AAFA;EACI,eAAA;EACA,sBAAA;EACA,cAAA;EACA,iBAAA;EACA,sBAAA;AAKJ;;AAHA;EACI,SAAA;AAMJ;;AAJA;EACI,iBAAA;AAOJ;;AALA;EACI,iBAAA;EACA,YAAA;EACA,iBAAA;EACA,yBAAA;EACA,kBAAA;AAQJ;;AANA;EAA4C,iBAAA;AAU5C;;AATA;EAA6C,UAAA;AAa7C;;AAZA;EAA6C,UAAA;AAgB7C;;AAfA;EAA6C,UAAA;AAmB7C;;AAlBA;EAA6C,UAAA;AAsB7C;;AArBA;EAA6C,UAAA;AAyB7C;;AAxBA;EAA6C,UAAA;AA4B7C;;AA3BA;EAA6C,UAAA;AA+B7C;;AA9BA;EAA6C,UAAA;AAkC7C;;AAjCA;EACI,aAAA;EACA,uBAAA;AAoCJ;;AAlCA;EACI,aAAA;EACA,SAAA;EACA,yBAAA;EACA,gBAAA;AAqCJ;;AAnCI;EACI,aAAA;EACA,sBAAA;AAsCR;;AApCI;EACI,aAAA;EACA,yBAAA;EACA,mBAAA;AAuCR;;AArCI;EACI,eAAA;AAwCR;;AAtCI;EACI,aAAA;AAyCR;;AAvCI;EACI,gBAAA;EACA,eAAA;EACA,gBAAA;EACA,cAAA;AA0CR;;AAxCI;EACI,kBAAA;EACA,aAAA;EACA,MAAA;EACA,OAAA;EACA,QAAA;EACA,SAAA;EACA,mBAAA;EACA,uBAAA;EACA,mBAAA;EACA,oCAAA;AA2CR;;AAzCI;EACI,kCAAA;EACA,cAAA;EACA,WAAA;AA4CR;;AA1CA,oBAAA;AACA;EACI,aAAA;EACA,YAAA;EACA,yBAAA;AA6CJ;;AA3CI;EACI,aAAA;EACA,iBAAA;EACA,mBAAA;AA8CR;;AA5CI;EACI,WAAA;EACA,YAAA;EACA,WAAA;EACA,kBAAA;EACA,yBAAA;AA+CR;;AA7CI;EACI,WAAA;EACA,yBAAA;AAgDR;;AA9CI;EACI,sBAAA;AAiDR;;AA9CA,iBAAA;AACA;EACI,UAAA;EACA,aAAA;EACA,mBAAA;EACA,gBAAA;EACA,uBAAA;AAiDJ;;AA/CI;EACI,UAAA;EACA,kBAAA;EACA,aAAA;EACA,gBAAA;EACA,iBAAA;EACA,sBAAA;AAkDR;;AAhDI;EACI,aAAA;EACA,cAAA;EACA,uBAAA;AAmDR;;AAjDI;EACI,aAAA;EACA,UAAA;EACA,sBAAA;EACA,kBAAA;EACA,eAAA;AAoDR;;AAlDI;EACI,cAAA;EACA,WAAA;EACA,eAAA;AAqDR;;AAnDI;EACI,aAAA;EACA,iBAAA;EACA,UAAA;EACA,yBAAA;EACA,kBAAA;EACA,eAAA;EACA,mBAAA;EACA,uBAAA;AAsDR;;AApDI;EACI,YAAA;EACA,yBAAA;AAuDR;;AArDI;EACI,aAAA;EACA,cAAA;EACA,mBAAA;EACA,sBAAA;EACA,yBAAA;EACA,gBAAA;AAwDR;;AAtDQ;EACI,aAAA;EACA,aAAA;EACA,WAAA;EACA,uBAAA;EACA,mBAAA;AAyDZ;;AAvDY;EACI,aAAA;EACA,WAAA;EACA,mBAAA;EACA,8BAAA;AA0DhB;;AAxDY;EACI,aAAA;AA2DhB;;AAzDY;EACI,aAAA;EACA,SAAA;EACA,mBAAA;EACA,eAAA;AA4DhB;AA1DgB;EACI,iBAAA;AA4DpB;;AAzDY;EACI,aAAA;EACA,mBAAA;EACA,yBAAA;EACA,WAAA;EACA,YAAA;EACA,UAAA;AA4DhB;;AA1DY;EACI,aAAA;EACA,iBAAA;EACA,2BAAA;EACA,mBAAA;AA6DhB;;AA3DY;EACI,aAAA;EACA,cAAA;EACA,qBAAA;AA8DhB;;AA5DY;EACI,kBAAA;EACA,aAAA;AA+DhB;;AA7DI;EACI,kBAAA;EACA,MAAA;EACA,OAAA;EACA,QAAA;EACA,SAAA;EACA,oCAAA;AAgER;;AA7DA;EACI,aAAA;EACA,sBAAA;AAgEJ;;AA9DI;EACI,aAAA;EACA,iBAAA;AAiER;;AA/DI;EACI,aAAA;EACA,gBAAA;EACA,mBAAA;EACA,uBAAA;EACA,yBAAA;EACA,yBAAA;EACA,mBAAA;AAkER;;AAhEI;EACI,kBAAA;AAmER;;AAjEI;EACI,aAAA;EACA,iBAAA;EACA,YAAA;EACA,iBAAA;AAoER;;AAlEI;EACI,kBAAA;AAqER;;AAnEQ;EACI,aAAA;EACA,kBAAA;EACA,MAAA;EACA,OAAA;EACA,QAAA;EACA,SAAA;EACA,aAAA;EACA,YAAA;EACA,mBAAA;AAsEZ;;AApEY;EACI,aAAA;EACA,sBAAA;AAuEhB;;AApEQ;EACI,iBAAA;EACA,UAAA;EACA,WAAA;EACA,sBAAA;AAuEZ;;AArEY;EACI,aAAA;EACA,sBAAA;AAwEhB;;AAtEQ;EACI,YAAA;EACA,iBAAA;AAyEZ;;AAvEQ;EACI,iBAAA;AA0EZ;;AAxEQ;EACI,YAAA;EACA,iBAAA;AA2EZ;;AAxEQ;EACI,aAAA;EACA,sBAAA;AA2EZ;;AAzEQ;EACI,UAAA;EACA,YAAA;EACA,yBAAA;AA4EZ;;AA1EgB;EACI,aAAA;EACA,cAAA;EACA,6BAAA;AA6EpB;;AA3EgB;EACI,SAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,UAAA;EACA,iBAAA;AA8EpB;;AA5EgB;EACI,gBAAA;AA+EpB;;AA7EgB;EACI,aAAA;EACA,cAAA;EACA,eAAA;EACA,sBAAA;AAgFpB;;AA9EoB;EACI,aAAA;AAiFxB;;AA/EoB;EACI,aAAA;EACA,eAAA;EACA,UAAA;EACA,YAAA;EACA,uBAAA;EACA,mBAAA;AAkFxB;;AAhFoB;EACI,gBAAA;AAmFxB;;AAjFoB;EACI,WAAA;EACA,yBAAA;AAoFxB;;AAlFoB;EACI,yBAAA;AAqFxB;;AAnFoB;EACI,WAAA;AAsFxB;;AApFoB;EACI,eAAA;EACA,kBAAA;EACA,iBAAA;EACA,uHAAA;AAuFxB;;AAjFoB;EACI,eAAA;EACA,kBAAA;EACA,uHAAA;EAKA,sBAAA;AAgFxB;;AA9EoB;EACI,gBAAA;EACA,aAAA;AAiFxB;;AA/EwB;EACI,SAAA;EACA,aAAA;EACA,sBAAA;AAkF5B;;AAhFwB;EACI,oBAAA;EACA,iBAAA;AAmF5B;;AAjFwB;EACI,yBAAA;AAoF5B;;AAlFwB;EACI,yBAAA;AAqF5B;;AAnFwB;EACI,eAAA;EACA,kBAAA;EACA,iBAAA;EACA,iBAAA;EACA,yBAAA;AAsF5B;;AApFwB;EACI,kBAAA;EACA,yBAAA;EACA,sBAAA;AAuF5B;;AArFwB;EACI,iBAAA;AAwF5B;;AAtFwB;EACI,kBAAA;AAyF5B","sourcesContent":["/* PayTable */\n.SSPTable {\n    flex: 1;\n    display: flex;\n    position: relative;\n    margin-top: 10px;\n    background-color: #fff;\n}\n.SSPTable table {\n    position: relative;\n    width: 100%;\n    text-align: center;\n    border-radius: 10px;\n    border-collapse: collapse;\n    border-style: hidden;\n    box-shadow: 0 0 0 1px #e9e9e9;\n    overflow: hidden;\n}\n.SSPTable table thead {\n    font-weight: bold;\n    background-color: #f9fafb;\n}\n.SSPTable table tr th {\n    padding: 15px 0;\n    text-align: center;\n    border: 1px solid #ddd;\n}\n.SSPTable table tr td {\n    padding: 15px 0;\n    vertical-align: middle;\n    color: #505054;\n    font-weight: bold;\n    border: 1px solid #ddd;\n}\n.SSPTable table tr td p {\n    margin: 0;\n}\n.SSPTable table tr td p+p {\n    font-size: 0.7rem;\n}\n.SSPTable table tr td input[type=text] {\n    padding: 3px 10px;\n    height: 40px;\n    text-align: right;\n    border: 1px solid #e9e9e9;\n    border-radius: 5px;\n}\n.SSPTable table tr td input[type=text].RB { border-color: red; }\n.SSPTable table tr td input[type=text].W90 { width: 90%; }\n.SSPTable table tr td input[type=text].W80 { width: 80%; }\n.SSPTable table tr td input[type=text].W70 { width: 70%; }\n.SSPTable table tr td input[type=text].W60 { width: 60%; }\n.SSPTable table tr td input[type=text].W50 { width: 50%; }\n.SSPTable table tr td input[type=text].W40 { width: 40%; }\n.SSPTable table tr td input[type=text].W30 { width: 30%; }\n.SSPTable table tr td input[type=text].W20 { width: 20%; }\n.SSPTable table tr td .AmountTd {\n    display: flex;\n    justify-content: center;\n}\n.SSPTable table tr td .AmountTd div {\n    display: flex;\n    flex: 1;\n    justify-content: flex-end;\n    max-width: 177px;\n}\n    .SectionPayInput {\n        display: flex;\n        flex-direction: column;\n    }\n    .SectionPayInput .SectionPayInner {\n        display: flex;\n        justify-content: flex-end;\n        align-items: center;\n    }\n    .SectionPayInput .SectionPayInner+.SectionPayInner {\n        margin-top: 5px;\n    }\n    .SectionPayInput input {\n        margin: 0 5px;\n    }\n    .SectionPayInput span {\n        margin-right: 3%;\n        font-size: 1rem;\n        font-weight: 400;\n        color: #868686;\n    }\n    .SSPTableLoading {\n        position: absolute;\n        display: flex;\n        top: 0;\n        left: 0;\n        right: 0;\n        bottom: 0;\n        align-items: center;\n        justify-content: center;\n        border-radius: 20px;\n        background-color: rgba(0,0,0,0.1);\n    }\n    .spinnerIcon {\n        animation: spin 2s linear infinite;\n        font-size: 2em;\n        color: #555\n    }\n/* SectionSumInput */\n.SectionSumInput {\n    display: flex;\n    margin: 0 5%;\n    justify-content: flex-end;\n}\n    .SectionSumInput .SectionSumType {\n        display: flex;\n        margin-right: 2px;\n        align-items: center;\n    }\n    .SectionSumInput .SectionSumType button {\n        width: 30px;\n        height: 30px;\n        color: #aaa;\n        border-radius: 4px;\n        border: 1px solid#e9e9e9;\n    }\n    .SectionSumInput .SectionSumType button.isActive {\n        color: #fff;\n        background-color: #bc1a21;\n    }\n    .SectionSumInput .SectionSumType button:not(.isActive):hover {\n        background-color: #eee;\n    }\n\n/* SectionPopup */\n.SectionPopup {\n    z-index: 2;\n    display: flex;\n    align-items: center;\n    max-height: 70vh;\n    justify-content: center;\n}\n    .SectionPopupInner {\n        z-index: 2;\n        position: relative;\n        display: flex;\n        min-width: 420px;\n        max-height: 99.5%;\n        flex-direction: column;\n    }\n    .SectionAdd {\n        display: flex;\n        margin-top: 5%;\n        justify-content: center;\n    }\n    .SectionAdd input {\n        padding: 10px;\n        width: 50%;\n        border: 1px solid #ddd;\n        border-radius: 5px;\n        font-size: 1rem;\n    }\n    .SectionAdd input::placeholder {\n        padding: 0 5px;\n        color: #999;\n        font-size: 1rem;\n    }\n    .SectionAdd button {\n        display: flex;\n        margin-left: 10px;\n        width: 20%;\n        border: 1px solid #bc1a21;\n        border-radius: 5px;\n        font-size: 1rem;\n        align-items: center;\n        justify-content: center;\n    }\n    .SectionAdd button:hover {\n        color: white;\n        background-color: #bc1a21;\n    }\n    .SectionList {\n        display: flex;\n        margin-top: 5%;\n        align-items: center;\n        flex-direction: column;\n        border: 1px solid #f5f5f5;\n        overflow-y: auto;\n    }\n        .SectionItem {\n            display: flex;\n            padding: 10px;\n            width: 100%;\n            justify-content: center;\n            align-items: center;\n        }\n            .SectionListCheckBox {\n                display: flex;\n                width: 100%;\n                align-items: center;\n                justify-content: space-between;\n            }\n            .SectionListCheckBox input {\n                display: none;\n            }\n            .SectionListCheckBox label {\n                display: flex;\n                margin: 0;\n                align-items: center;\n                cursor: pointer;\n\n                &:hover {\n                    font-weight: bold;\n                }\n            }\n            .SectionListCheckBox label .SectionListCheckBoxIcon {\n                display: flex;\n                align-items: center;\n                justify-content: flex-end;\n                width: 22px;\n                height: 24px;\n                padding: 0;\n            }\n            .SectionListName {\n                display: flex;\n                margin-left: 20px;\n                justify-content: flex-start;\n                align-items: center;\n            }\n            .SectionListName span {\n                display: flex;\n                min-width: 30%;\n                align-content: center;\n            }\n            .SectionListCheckBox button {\n                padding-left: 10px;\n                display: flex;\n            }\n    .SectionPopupBg {\n        position: absolute;\n        top: 0;\n        left: 0;\n        right: 0;\n        bottom: 0;\n        background-color: rgba(0,0,0,0.3);\n    }\n\n.DP_Top {\n    display: flex;\n    flex-direction: column;\n}\n    .DP_TopBackArea {\n        display: flex;\n        margin-bottom: 2%;\n    }\n    .DP_TopBackArea button {\n        display: flex;\n        padding: 0.5% 3%;\n        align-items: center;\n        justify-content: center;\n        background-color: #a6c23d;\n        border: 1px solid #a6c23d;\n        border-radius: 10px;\n    }\n    .DP_TopBackArea button:hover {\n        border-color: #000;\n    }\n    .DP_TopBackArea button span {\n        display: flex;\n        margin-left: 10px;\n        color: white;\n        font-size: 1.1rem;\n    }\n    .DP_TopBg {\n        position: relative;\n    }\n        .DP_TopCnt {\n            display: flex;\n            position: absolute;\n            top: 0;\n            left: 0;\n            right: 0;\n            bottom: 0;\n            padding: 0 5%;\n            color: white;\n            align-items: center;\n        }\n            .DP_TopName {\n                display: flex;\n                flex-direction: column;\n            }\n        \n        .DP_TopCnt i {\n            margin: 0 2% 0 5%;\n            width: 1px;\n            height: 50%;\n            background-color: #fff;\n        }\n            .DP_TopInfo {\n                display: flex;\n                flex-direction: column;\n            }\n        .DP_TopCnt span {\n            color: white;\n            font-size: 1.5rem;\n        }\n        .DP_TopCnt span+span {\n            font-size: 1.3rem;\n        }\n        .DP_TopCnt strong {\n            color: white;\n            font-size: 2.5rem;\n        }\n\n        .DP_Mid {\n            display: flex;\n            flex-direction: column;\n        }\n        .DP_Mid .DP_MidBar {\n            width: 1px;\n            height: 100%;\n            background-color: #C7C7C7;\n        }\n                .DP_MidMenu {\n                    display: flex;\n                    margin-top: 5%;\n                    justify-content: space-evenly;\n                }\n                .DP_MidMenu button {\n                    flex: 1;\n                    display: flex;\n                    align-items: center;\n                    justify-content: center;\n                    padding: 0;\n                    font-size: 1.2rem;\n                }\n                .DP_MidMenu button span {\n                    margin-top: 10px;\n                }\n                .DP_MidSection {\n                    display: flex;\n                    margin-top: 4%;\n                    padding-top: 4%;\n                    flex-direction: column;\n                }\n                    .SectionTitle {\n                        display: flex;\n                    }\n                    .SectionTitle span {\n                        display: flex;\n                        padding: 10px 0;\n                        width: 10%;\n                        color: white;\n                        justify-content: center;\n                        border-radius: 27px;\n                    }\n                    .DP_MidEmpInfo {\n                        margin-top: 10px;\n                    }\n                    .DP_MidEmpInfo table {\n                        width: 100%;\n                        border-collapse: collapse;\n                    }\n                    .DP_MidEmpInfo table thead {\n                        background-color: #F3FBFF;\n                    }\n                    .DP_MidEmpInfo table {\n                        width: 100%;\n                    }\n                    .DP_MidEmpInfo table th {\n                        padding: 10px 0;\n                        text-align: center;\n                        font-weight: bold;\n                        box-shadow: 1px 0 0 0 #C5C5C5, \n                        0 1px 0 0 #C5C5C5, \n                        1px 1px 0 0 #C5C5C5,\n                        1px 0 0 0 #C5C5C5 inset, \n                        0 1px 0 0 #C5C5C5 inset;\n                    }\n                    .DP_MidEmpInfo table td {\n                        padding: 10px 0;\n                        text-align: center;\n                        box-shadow: 1px 0 0 0 #C5C5C5, \n                        0 1px 0 0 #C5C5C5, \n                        1px 1px 0 0 #C5C5C5,\n                        1px 0 0 0 #C5C5C5 inset, \n                        0 1px 0 0 #C5C5C5 inset;\n                        background-color: #fff;\n                    }\n                    .DP_SectionTableArea {\n                        margin-top: 10px;\n                        display: flex;\n                    }\n                        .DP_SectionTable {\n                            flex: 1;\n                            display: flex;\n                            flex-direction: column;\n                        }\n                        .DP_SectionTable strong {\n                            padding-bottom: 10px;\n                            font-size: 1.2rem;\n                        }\n                        .DP_SectionTable table {\n                            border-collapse: collapse;\n                        }\n                        .DP_SectionTable table thead {\n                            background-color: #F3FBFF;\n                        }\n                        .DP_SectionTable table th {\n                            padding: 10px 0;\n                            text-align: center;\n                            font-weight: bold;\n                            font-size: 1.2rem;\n                            border: 1px solid #D5D5D5;\n                        }\n                        .DP_SectionTable table td {\n                            padding: 10px 20px;\n                            border: 1px solid #D5D5D5;\n                            background-color: #fff;\n                        }\n                        .DP_SectionTable table td:last-child {\n                            text-align: right;\n                        }\n                        .DP_SectionTable table td.DP_SectionTableFormula {\n                            text-align: center;\n                        }"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
